var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgData03 = function SvgData03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "data-03_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#data-03_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.257 3.214h.037a8.497 8.497 0 0 1 8.497 8.497h-8.534V3.214Zm-9.048 9.075a8.497 8.497 0 0 1 8.46-8.497v8.497h8.534a8.498 8.498 0 0 1-8.497 8.497c-4.692 0-8.497-3.816-8.497-8.497Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "data-03_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgData03 as ReactComponent };